/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  apiUrl: "",
  baseUrl: "",
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAEBCevBNBzS2m0cCdqFknPMwfe6oEHxtg",
    authDomain: "accounting-webspark.firebaseapp.com",
    projectId: "accounting-webspark",
    storageBucket: "accounting-webspark.firebasestorage.app",
    messagingSenderId: "665622862694",
    appId: "1:665622862694:web:5cef2d5de48de6bf3406a7"
  }
};
